import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UsersService } from '@app/core/services';
import { ActivateAccount } from '@core/models';
import { PasswordRequired } from '@core/models/account/password-required';
import { firstValueFrom } from 'rxjs';
import { ConfigService } from './config.service';

@Injectable()
export class AccountService {

  publicPath: string;

  constructor(private readonly configService: ConfigService, private readonly httpClient: HttpClient, private readonly usersService: UsersService) {
    this.publicPath = this.configService.appConfig.api.publicPath;
  }

  activateAccount(activateAccountData: ActivateAccount): Promise<any> {
    return firstValueFrom(this.httpClient.post(`${this.publicPath}/uo/activate`, activateAccountData));
  }

  isPasswordRequired(id: string): Promise<any> {
    return firstValueFrom(this.httpClient.get<PasswordRequired>(`${this.publicPath}/uo/isPasswordRequired/${id}`));
  }

  getCaptchaApiKey(): Promise<{ apiKey: string }> {
    return firstValueFrom(this.httpClient.get<{ apiKey: string }>(`${this.publicPath}/uo/captcha`));
  }
}
